export const formatDate = (date: Date | string): string => {
    const parsedDate = typeof date === 'string' ? new Date(date) : date;
    return parsedDate.toLocaleDateString('tr-TR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
};

export const calculateAddedDate = (date: Date, addedDate: number): Date => {
    const nextWeekDate = new Date(date);
    nextWeekDate.setDate(date.getDate() + addedDate);
    return nextWeekDate;
};
